module.exports = __webpack_public_path__ + "img/tuiguang-title.a73b97ba.png";